module.exports = __webpack_public_path__ + "img/circle1GreenBig.c25b8d0d.svg";